import { render, staticRenderFns } from "./ModalConfirmation.vue?vue&type=template&id=e2868404&scoped=true&"
import script from "./ModalConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmation.vue?vue&type=style&index=0&id=e2868404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2868404",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2868404')) {
      api.createRecord('e2868404', component.options)
    } else {
      api.reload('e2868404', component.options)
    }
    module.hot.accept("./ModalConfirmation.vue?vue&type=template&id=e2868404&scoped=true&", function () {
      api.rerender('e2868404', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/ModalConfirmation.vue"
export default component.exports